import React , {useEffect, useState } from 'react'
import Container from '@mui/material/Container';
import Autocomplete from '@mui/material/Autocomplete';
import TextField, { getTextFieldUtilityClass } from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
// asi se declaran los colores extras
import { grey  } from '@mui/material/colors'; // , lime, purple

import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ErrorIcon from '@mui/icons-material/Error';
import DoneIcon from '@mui/icons-material/Done';

function Logos() {
  const [seleccionados, setSeleccionados] = useState(false);
    const[titulo,setTitulo] = useState('');
    const[termino,setTermino] = useState('');
    const[logo,setLogo] = useState('');
    const[mensaje,setMensaje] = useState('');
    const [archivo, setArchivo] = useState('');

 
    const [open, setOpen] = React.useState(false);
    const [provincias,setProvincias] = useState([]);
    const [localidades,setLocalidades] = useState([]);
    const [selectedOptionProvincia, setSelectedOptionProvincia] = useState(null);
    const [selectedOptionLocalidad, setSelectedOptionLocalidad] = useState(null);

    const theme = createTheme({
        palette: {
       //   primary: lime,
          secondary: grey,
        },
      });

    const handleClose = () => {
        setOpen(false);
      };

     const handleOptionChangeLocalidades = (event , value) => {
    //  event.preventDefault();
     // console.log(value);
      if (value !== null) {
          setSelectedOptionLocalidad(value.localidad);

          getTermino(value.localidad);
            if (selectedOptionProvincia !== null && selectedOptionLocalidad !== null)
              {setSeleccionados(true)}
          else
          {setSeleccionados(false)}
        }
      else
      {setSeleccionados(false)}
  
    }
      const handleOptionChangeProvincias = (event, value) => {
        setSelectedOptionProvincia(value.provincia);
        // cambio las localidad segun la provincia selecconada
        
        if (value != null) {
          getLocalidades(value.provincia);
              setLocalidades(value.provincia);
        }
        else {
          setLocalidades([]);
        }
      }

      const handleSubmitTerminos = async (event) => {
        event.preventDefault();
            try {
              const postData = {
                provincia : selectedOptionProvincia,
                localidad : selectedOptionLocalidad,
                terminos : termino
              };
                const baseURL = process.env.REACT_APP_SERVER_PATH + 'addTermino';
                const res = await fetch(`${baseURL}`, {
                  method: "post",
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": "token-value",
                    'Access-Control-Allow-Origin': '*'
                  },
                  body: JSON.stringify(postData),
                });
      
                if (res.status === 200) {
                  setTitulo('Información');
                  setMensaje('Envio correcto')
                   setOpen(true);
                  
                } else
                if (res.status === 500) 
                 {
                  setTitulo('Error');
                  setMensaje('Error al enviar el archivo')
                   setOpen(true);
                 }
  
                    } catch (err) {
                      setTitulo('Error');
                      setMensaje('Error al enviar el archivo')
                      setOpen(true);
                     // console.log(err.message)
              }
            //
      };

      const handleSubmit = async (event) => {
        event.preventDefault();
        if (selectedOptionProvincia === null || selectedOptionLocalidad === null)
          return ; 
        const formData = new FormData();
        formData.append('sampleFile', archivo);
        formData.append('provincia',selectedOptionProvincia);
        formData.append('localidad',selectedOptionLocalidad);
            //
            try {
                const baseURL = process.env.REACT_APP_SERVER_PATH + 'logo/'+logo;
                const res = await fetch(`${baseURL}`, {
                  method: "POST",
                  body: formData,
                });
      
                if (res.status === 200) {
                  setTitulo('Información');
                  setMensaje('Envio correcto')
                   setOpen(true);
                  
                } else
                if (res.status === 500) 
                 {
                  setTitulo('Error');
                  setMensaje('Error al enviar el archivo')
                   setOpen(true);
                 }
  
                    } catch (err) {
                      setTitulo('Error');
                      setMensaje('Error al enviar el archivo')
                      setOpen(true);
                      console.log(err.message)
              }
            //
      };


      const handleFileChange = (event) => {
          setArchivo(event.target.files[0]);
        };

          const getTermino = (valor) => {
            // const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales/'+selectedOptionProvincia+'/'+valor;
            const baseURL = process.env.REACT_APP_SERVER_PATH+'getTermino/'+selectedOptionProvincia+'/'+valor;
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { 
                setTermino(result[0].terminos);
               //console.log({termino})
              },
              (error) => {
              }
            )
           }
           
           const getProvincias = () => {
            const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getProvincias';
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { setProvincias(result) 
              },
              (error) => {
              }
            )
           }
    
           const getLocalidades = (selected) => {
            const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getLocalidades/'+selected;
            fetch(`${baseURL}`)
            .then(res => res.json())
            .then(
              (result) => { setLocalidades(result) 
              },
              (error) => {
              }
            )
           }

           const handleChange = (event) => {
            setLogo(event.target.value);
          };

        useEffect(() => {  
            getProvincias();  
              

            // eslint-disable-next-line    
        },[])
      
  return (
    <>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {titulo}

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {mensaje}
          {/* Información */ }
          {mensaje == "Envio correcto" ? (<DoneIcon />):(<ErrorIcon />)}
        
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <ThemeProvider theme={theme}>

    <Container component="main" maxWidth="lg" style={{ marginTop: "30px",marginBottom: "30px"}}>
    <h1>Seleccione Provincia y Localidad, luego cargue los logos correspondientes:</h1>
    
    <Grid container spacing={1}>
      <Grid item xs={6} >
          <Autocomplete sx = {{mt : 2}}
                      id="auto"
                      options={provincias}
                      getOptionLabel={(provincias) => provincias.provincia}
                      renderInput={(params) => <TextField {...params} label="Provincia" variant="outlined" />}
                      onChange={handleOptionChangeProvincias}
                      />
      </Grid>
      <Grid item xs={6} >
          <Autocomplete sx = {{mt : 2}}
                  id="auto"
                  options={localidades}
                  getOptionLabel={(localidades) => localidades.localidad}
                  renderInput={(params) => <TextField {...params} label="Localidad" variant="outlined" />}
                onChange={handleOptionChangeLocalidades}
                  //onChange = {(e) => {setSelectedOptionLocalidad( e.target.value)}}
                  />  
      </Grid>
                            
    </Grid>
    <h1>Terminos y condiciones</h1>
    <Box component="form" onSubmit={handleSubmitTerminos}   sx={{ mt: 3 }}>
    <TextField fullWidth required value = {termino} onChange = { (e) => (setTermino(e.target.value))}/>
        <Button variant="contained"  sx={{ mt: 4, mb: 1 }}  type="submit">
        Guarda Terminos
      </Button>
      </Box>

       
    <h1>Carga logos</h1>
    <Box component="form" onSubmit={handleSubmit} encType="multipart/form-data" sx={{ mt: 3 }}>


    <Grid container spacing={1}>
   
    <InputLabel id="demo-simple-select-label">Posición Logo</InputLabel>
    <Grid item xs={2} >  <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={logo}
          label="Logo"
          onChange={handleChange}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={4}>4</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={6}>6</MenuItem>
          <MenuItem value={7}>7</MenuItem>
          <MenuItem value={8}>8</MenuItem>
        </Select>
    </Grid>
        <Grid item xs={2} >
            <input
            accept=".jpg,.png"
            style={{ display: 'none' }}
            id="file-input"
            type="file"
            name="sampleFile"
            onChange={handleFileChange}
            />
            <label htmlFor="file-input">
            <Button variant="contained" color="secondary" component="span">
            LOGO
            </Button>
            </label>
        </Grid>
        <Grid item xs={2} >
            <Button type="submit" variant="contained" color="primary" >
                Guardar cambios
            </Button>
                {archivo && <p>Archivo seleccionado: {archivo.name}</p>}
        </Grid>
 
        </Grid> 
</Box>

    </Container>
    </ThemeProvider>
    </>
  )
}

export default Logos